import { render } from "./UserMenu.vue?vue&type=template&id=717e61b4"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script